import './AccordionItem.css';
import React from 'react';
import { get, injectImageResolution } from '../../utils';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { ReactComponent as IconPlus } from '../../resources/icons/accordion-plus.svg';
import { ReactComponent as IconMinus } from '../../resources/icons/accordion-minus.svg';
import { ReactComponent as IconChevronDown } from '../../resources/icons/arrowDownC.svg';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import LazyPicture from '../atoms/LazyPicture';
const BASE_URL = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
export const AccordionItem = _ref => {
  let {
    isActive,
    item,
    pageEditing,
    onChange,
    isDetSite,
    isTwoColumns
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const titleField = get(item, 'title.jss');
  const description = get(item, 'description.jss');
  const iconSvgCode = get(item, 'iconSvgCode.jss.value');
  const commonStyles = isDetSite ? "cgn4e1k" : "cnxugok";
  const ltrStyles = isDetSite ? "l1siopd0" : "l55f0m6";
  const rtlStyles = isDetSite ? "r1j8eh9r" : "rwu7k7s";
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `accordion-item ${isActive ? "accordion-item--active" : ""}`,
    key: item.id
  }, /*#__PURE__*/React.createElement("p", {
    className: "accordion-item__heading body-medium",
    onClick: e => {
      if (!pageEditing) {
        e.preventDefault();
        onChange && onChange(e);
      }
    },
    onKeyPress: e => {
      if (e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        onChange && onChange(e);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapIconAndTitle"
  }, iconSvgCode && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: iconSvgCode
    },
    className: "title__icon"
  }), /*#__PURE__*/React.createElement(Text, {
    tag: pageEditing ? 'span' : 'a',
    className: "accordion__anchor",
    href: "/",
    field: titleField,
    "data-cy": "accordion-faq-anchor"
  })), !pageEditing && !isDetSite && /*#__PURE__*/React.createElement("span", {
    className: "accordion-item__icon"
  }, isActive ? /*#__PURE__*/React.createElement(IconMinus, null) : /*#__PURE__*/React.createElement(IconPlus, null)), !pageEditing && isDetSite && /*#__PURE__*/React.createElement("span", {
    className: "accordion-item__icon"
  }, /*#__PURE__*/React.createElement(IconChevronDown, {
    className: `${isActive ? "iconDown" : "iconUp"}`
  }))), isActive && /*#__PURE__*/React.createElement("div", {
    className: "accordion-item__content"
  }, item.image && get(item.image, "jss.value.src") && /*#__PURE__*/React.createElement(LazyPicture, {
    className: `accordion-item__img ${isTwoColumns ? "accordion-item__img-twoColumn" : "accordion-item__img-horizontal"}`
  }, /*#__PURE__*/React.createElement("source", {
    srcSet: item.image.jss.value.src ? injectImageResolution(`${BASE_URL}${item.image.jss.value.src}`, 580, 240) : "",
    media: "(min-width: 768px)"
  }), /*#__PURE__*/React.createElement("img", {
    src: item.image.jss.value.src ? injectImageResolution(`${BASE_URL}${item.image.jss.value.src}`, 1005, 540) : "",
    alt: item.image.jss.value.alt
  })), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "body-small accordion-item__desc",
    field: description,
    "data-cy": "accordion-faq-item-content"
  }))));
};